function ArrowDown({ dimensions, col = '#000' }) {
  const baseXml = `

    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5137_14991)">
      <path d="M7 10L12 15L17 10H7Z" fill="black" fill-opacity="0.54"/>
      </g>
      <defs>
      <clipPath id="clip0_5137_14991">
      <rect width=${dimensions || '24'} height=${dimensions || '24'} fill="white"/>
      </clipPath>
      </defs>
    </svg>

  `;

  return baseXml;
}

export default ArrowDown;
